<template>
  <BreadCrumb PageTitle=" Liste des services" />
    <ListeService />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import ListeService from "@/components/Service/ListeService.vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  
    export default defineComponent({
      name: "ListeServicePage",
      components: {
        ListeService,
      },
    });
  </script>